import { AxiosRequestConfig } from 'axios';
import {
  Requisite,
  RequisiteDeletePayload,
  RequisiteSiblings,
  RequisitesPayload,
} from 'Interfaces/Requisite';
import { TokenizedPayload } from 'Interfaces/User';

import Api from './Api';

class RequisiteApi extends Api {
  getRequisites = (payload?: TokenizedPayload<{ withDeleted?: boolean }>) => {
    const { token, payload: params } = payload || {};

    return this.request.get(token)<Requisite[]>('requisites', { params });
  };

  createRequisites = async (
    { token, payload }: TokenizedPayload<RequisitesPayload>,
    config?: AxiosRequestConfig,
  ) => {
    return this.request.post(token)<RequisiteSiblings>(
      'requisites',
      { requisites: payload },
      config,
    );
  };

  updateRequisites = async (
    { token, payload }: TokenizedPayload<RequisitesPayload>,
    config?: AxiosRequestConfig,
  ) => {
    return this.request.patch(token)<RequisiteSiblings>(
      `requisites`,
      { requisites: payload },
      config,
    );
  };

  deleteRequisite = async (
    { token, payload }: TokenizedPayload<RequisiteDeletePayload>,
    config?: AxiosRequestConfig,
  ) => this.request.delete(token)<RequisiteSiblings>(`requisites/${payload.id}`, config);
}

export default new RequisiteApi();
